/**
 * This function checks whether a Discovery page route is requested which does not have a locale.
 * This pages are now deprecated and as such are redirected
 *
 * For example:
 * /running-events/in-london -> /gb/running-events/in-london
 * /triathlon-events/olympic/in-california -> /us/triathlon-events/olympic/in-california
 *
 * Whereas routes without locations and without locale are still fine.
 *
 * For example:
 * /running-events
 * /triathlon-events/olympic
 */
export const redirectDiscoveryWithLocationWithoutLocale = (
  { params: { filterSlug, locationSlug, sportSlug } },
  replace,
) => {
  if (locationSlug) {
    const localeSlug = locationSlug === 'california' ? 'us' : 'gb';
    replace({
      pathname: filterSlug
        ? `/${localeSlug}/${sportSlug}-events/${filterSlug}/in-${locationSlug}`
        : `/${localeSlug}/${sportSlug}-events/in-${locationSlug}`,
    });
  }
};



// WEBPACK FOOTER //
// ./app/src/routes/helpers.js